import React from 'react';
import { Outline, type OutlineProps } from './Variants/Outline/Outline';

export const CheckBoxVariants = {
  OUTLINE: 'Outline',
} as const;

type CheckBoxProps =
  | ({ variant: typeof CheckBoxVariants.OUTLINE } & OutlineProps);

export const CheckBox: React.FC<CheckBoxProps> = React.memo((props) => {
  switch (props.variant) {
    case CheckBoxVariants.OUTLINE:
      return <Outline {...props} />;
  }
});

CheckBox.displayName = 'CheckBox';
